import store from '@/state/store'
import influencerRoutes from "./influencerRoutes";
import clientRoutes from "./clientRoutes";
import adminRoutes from "./adminRoutes";
import superAdminRoutes from "@/router/superAdminRoutes";
import employeeRoutes from "@/router/employeeRoutes";

adminRoutes.map((route) => {
    if (!route.meta) {
        route.meta = {}
    }
    route.meta.userType = 'admin'
    return route
})

influencerRoutes.map((route) => {
    if (!route.meta) {
        route.meta = {}
    }
    route.meta.userType = 'influencer'
    return route
})

clientRoutes.map((route) => {
    if (!route.meta) {
        route.meta = {}
    }
    route.meta.userType = 'client'
    return route
})

const routes = [
    ...superAdminRoutes,
    ...adminRoutes,
    ...employeeRoutes,
    {
        path: '/',
        name: 'root_page',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    return next({name: store.getters['user/homeRouteName']})
                } else {
                    // Continue to the login page
                    next({name: 'login', query: {redirectFrom: routeTo.fullPath}})
                }
            },
        },
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('./views/account/profile'),
        meta: {
            authRequired: true,
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./views/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    return next({name: store.getters['user/homeRouteName']})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('./views/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: store.getters['user/homeRouteName']})
                } else {
                    // Continue to the register page
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot password',
        component: () => import('./views/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: store.getters['user/homeRouteName']})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/reset-password',
        name: 'Reset password',
        component: () => import('./views/account/change-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: store.getters['user/homeRouteName']})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch('auth/logOut')
                } else {
                    store.dispatch('authfack/logout')
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push('/login')
                )
                // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? {name: store.getters['user/homeRouteName']} : {...routeFrom})
            },
        },
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: () => import('./views/privacyPolicy/privacyPolicy'),
    },
    {
        path: '/ariba-shop',
        name: 'Ariba Shop',
        component: () => import('./views/ariba/aribaCartView.vue'),
        meta: {
            authRequired: false,
            isAriba: true,
        },
    },
    {
        path: '/ariba-error',
        name: 'Ariba Error',
        component: () => import('./views/ariba/aribaErrorView.vue'),
        meta: {
            authRequired: false,
        },
    },
    {
        path: '/',
        name: 'redirect',
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: store.getters['user/homeRouteName']})
                } else {
                    // Continue to the register page
                    next({ name: 'login'})
                }
            },
        },
    },
    {
        path: '*',
        name: '404',
        component: require('./views/utility/404').default,
    },
]

export default routes
